import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'irembogov-disclaimer',
  templateUrl: './irembogov-disclaimer.component.html',
  styleUrls: ['./irembogov-disclaimer.component.scss'],
})
export class IrembogovDisclaimerComponent {}
